import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import GamePlayerScreen from './pages/game-player-screen';
import HomeLandingScreen from './pages/home-landing-screen';
import CreatorDashboard from './pages/creator-dashboard';
import DiscoverPage from './pages/discover';
import MarketplacePage from './pages/marketplace';
import VideoViewer from './pages/video-viewer';
import AnimationViewer from './pages/animation-viewer';
import MusicVideoPreview from './pages/music-video-preview';
import CreatorProfilePage from './pages/creator-profile';
import MonkeyRide from 'pages/monkey-ride/index';
import LibraryPage from './pages/library';
import PricingPage from './pages/pricing';
import CommunityGallery from 'pages/community-gallery/index';
import MusicToVideoPage from './pages/music-to-video';
import AdminCreatorsPage from './pages/admin/creators';
import CreatorReferralsPage from './pages/creator-referrals';
import CreatorAnalyticsPage from './pages/creator-analytics';
import AdminAnalyticsPage from './pages/admin/analytics';
import AuthPage from './pages/auth';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<Navigate to="/home-landing-screen" replace />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/game-player-screen" element={<GamePlayerScreen />} />
        <Route path="/play/:id" element={<GamePlayerScreen />} />
        <Route path="/home-landing-screen" element={<HomeLandingScreen />} />
        <Route path="/creator-dashboard" element={<CreatorDashboard />} />
        <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/marketplace" element={<MarketplacePage />} />
        <Route path="/video/:id" element={<VideoViewer />} />
        <Route path="/animation/:id" element={<AnimationViewer />} />
        <Route path="/music-video/:id" element={<MusicVideoPreview />} />
        <Route path="/creator/:username" element={<CreatorProfilePage />} />
        <Route path="/monkey-ride" element={<MonkeyRide />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/community-gallery" element={<CommunityGallery />} />
        <Route path="/music-to-video" element={<MusicToVideoPage />} />
        <Route path="/admin/creators" element={<AdminCreatorsPage />} />
        <Route path="/creator/referrals" element={<CreatorReferralsPage />} />
        <Route path="/creator/analytics" element={<CreatorAnalyticsPage />} />
        <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
